// StatusDonutMini — compact "count-by-status/severity/health" rollup ring.
// Pure CSS conic-gradient (no recharts / no useChartContainerWidth blank-render
// gotcha). Slice colors bind to executive-traffic-light tokens by tone name.

import './redesign.css';

const TONE = {
  sage: 'var(--status-sage)',
  amber: 'var(--status-amber)',
  brick: 'var(--status-brick)',
  blue: 'var(--status-blue)',
  slate: 'var(--status-slate)',
};

export function StatusDonutMini({
  segments = [],
  size = 96,
  totalLabel = 'Total',
  centerValue,
  ariaLabel = 'Status distribution',
}) {
  const data = segments.filter((s) => (s.count || 0) > 0);
  const total = data.reduce((a, s) => a + (s.count || 0), 0);
  let acc = 0;
  const stops = total
    ? data
        .map((s) => {
          const start = (acc / total) * 360;
          acc += s.count;
          const end = (acc / total) * 360;
          return `${TONE[s.tone] || TONE.slate} ${start.toFixed(2)}deg ${end.toFixed(2)}deg`;
        })
        .join(', ')
    : 'var(--color-surface-container-high) 0deg 360deg';
  const summary = data.length ? data.map((s) => `${s.label} ${s.count}`).join(', ') : 'no items';
  return (
    <div className="donut-mini" role="img" aria-label={`${ariaLabel}: ${summary}`}>
      <div
        className="donut-mini__ring"
        style={{ '--size': `${size}px`, background: `conic-gradient(${stops})` }}
      >
        <div className="donut-mini__hole">
          <span className="donut-mini__total">{centerValue ?? total}</span>
          <span className="donut-mini__total-label">{totalLabel}</span>
        </div>
      </div>
      {data.length ? (
        <ul className="donut-mini__legend">
          {data.map((s) => (
            <li key={s.label}>
              <span
                className="donut-mini__swatch"
                style={{ background: TONE[s.tone] || TONE.slate }}
              />
              <span className="donut-mini__legend-name">{s.label}</span>
              <span className="donut-mini__legend-count">{s.count}</span>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
